export const TOOLTIP_OFFSET = 16; // Gap between trigger and tooltip
export const TOOLTIP_HORIZONTAL_OFFSET = 16; // Horizontal offset to align content with trigger (matches tooltip padding)
export const VIEWPORT_PADDING = 8;
export const DEFAULT_HIDE_DELAY = 150; // Allows moving mouse to tooltip content
